<app-status-bar></app-status-bar>
<div class="wrapper passes-wrapper w-100">
    <div class="passes-layout">
        <div class="passes-main">

            <div class="passes-header">
        <div class="go-back" (click)="goBack()" style="cursor: pointer;">
            <i class="fa-sharp fa-thin fa-arrow-left"></i>
            <span>Volver</span>
        </div>
        <h2 class="passes-title">Abonos</h2>
    </div>

    <div class="cards-wrapper">
        <div class="row w-95" style="margin-bottom: 85px;">
            <div class="col-3 pb-4" *ngFor="let pass of passes; let i = index">
                <div class="pass-card-with-qty" (click)="selectPass(pass, i)">
                    <app-pass-card [pass]="pass"></app-pass-card>
                    <div class="pass-qty-row" (click)="$event.stopPropagation()">
                        <button class="qty-btn" (click)="changeQuantity(i, -1, $event)">−</button>
                        <span class="qty-value">{{ passQuantities[i] || 1 }}</span>
                        <button class="qty-btn" (click)="changeQuantity(i, 1, $event)">+</button>
                        <span class="qty-label">{{ (passQuantities[i] || 1) > 1 ? 'personas' : 'persona' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center py-5" *ngIf="!loadingSpinner && passes.length === 0">
                <p style="color: var(--color-light); font-size: 16px;">No hay abonos disponibles</p>
            </div>
        </div>
    </div>

    <div class="loading-spinner" *ngIf="loadingSpinner">
        <mat-progress-spinner color="accent" mode="indeterminate" diameter="40">
        </mat-progress-spinner>
    </div>
        </div><!-- end passes-main -->
        <div class="passes-cart">
            <app-products-resume></app-products-resume>
        </div>
    </div>
</div>
